import React  from 'react';

export const addPractitionerConfig = [
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/user-management-practitioners/add',
        component: React.lazy(() => import('./NewPractitioner')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/user-management-practitioners/edit',
        component: React.lazy(() => import('./PractitionerTabs')),
      },
    ],
  },
  
];
